import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, Space } from "antd";
import { toast } from "react-hot-toast";
import { postLoginRequest } from "../../service/postLoginRequest";

export const Login = () => {
  const onFinish = async (values: { username: string; password: string }) => {
    try {
      await postLoginRequest(values);
      window.location.href = "/";
    } catch (error) {
      toast.error("Erro ao realizar o login");
    }
  };

  return (
    <div className="login-container">
      <Space>
        <Card>
          <h1 className="login-title">Login</h1>
          <Form
            name="loginForm"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="username"
              rules={[
                { required: true, message: "Por favor, insira seu usuário!" },
              ]}
            >
              <Input prefix={<UserOutlined />} placeholder="Usuário" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Por favor, insira sua senha!" },
              ]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="Senha" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-button">
                Entrar
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Space>
    </div>
  );
};
